const localStorageAPIGet = function (storageName) {
    if (!storageName) return;
    const prefix = storageName.substring(0, 9);
    if (prefix === 'livechat_') {
        storageName = storageName.substring(prefix.length, storageName.length);
        return (
            ApexChat.localStorageAPI.Get(`apexchat_${storageName}`) ||
            ApexChat.localStorageAPI.Get(`livechat_${storageName}`)
        );
    }
    return ApexChat.localStorageAPI.Get(storageName);
};
export default localStorageAPIGet;
